module.exports = __webpack_public_path__ + "img/close-icon.b25ce8ae.png";